import { MosaicDragType } from '@/shared/components/Mosaic'
import { useDragLayer } from 'react-dnd'

export const useDragItemMonitor = () => {
  const dragState = useDragLayer((monitor) => ({
    isDragging: monitor.getItemType() === MosaicDragType.WIDGET_BUTTON,
  }))

  return dragState
}